import {
  applyBuildMulti,
  applyBuyTechCard,
  applyBuyTechCoin,
  applyEndPhase,
  applyMoveUnit,
  applyProduceUnit,
  applyRevealTechCard,
  applySurrender,
} from "./appliers";
import type {
  ApplyActionOutcome,
  GameState,
  TriAngerAction,
  ValidationResult,
} from "./types";
import { validateAction } from "./validators";

export function reduceGameState(
  state: GameState,
  action: TriAngerAction,
): GameState {
  const result = applyAction(state, action);
  return result.ok ? result.state : state;
}

export function applyAction(
  state: GameState,
  action: TriAngerAction,
): ApplyActionOutcome {
  const validation = validateAction(state, action);
  if (!validation.valid) return { ok: false, validation };

  switch (action.type) {
    case "MoveUnit":
      return { ok: true, state: applyMoveUnit(state, action) };
    case "ProduceUnit":
      return { ok: true, state: applyProduceUnit(state, action) };
    case "BuildMulti":
      return { ok: true, state: applyBuildMulti(state, action) };
    case "BuyTechCoin":
      return { ok: true, state: applyBuyTechCoin(state, action) };
    case "BuyTechCard":
      return { ok: true, state: applyBuyTechCard(state, action) };
    case "RevealTechCard":
      return { ok: true, state: applyRevealTechCard(state, action) };
    case "EndPhase":
      return { ok: true, state: applyEndPhase(state, action) };
    case "Surrender":
      return { ok: true, state: applySurrender(state, action) };
  }
}

export function validationError(error: string): ValidationResult {
  return { valid: false, error };
}
